// extracted by mini-css-extract-plugin
export default {"scrollContainer":"InvoicesGrid_scrollContainer__pRset"};